import { createDeliveryChargeValidation } from '../../utils/validationSchema';
import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import { useForm } from 'react-hook-form';
import DeliveryChargeForm from './DeliveryChargeForm';
import Form from '../../layouts/Form';
import useGetHook from '../../customHooks/useGetHook';
import APIS from '../../constant/EndPoint';
import ReturnRateForm from './ReturnRateForm';


const EditDeliveryCharge = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    clearErrors,
    watch
  } = useForm<any>({
    resolver: yupResolver(createDeliveryChargeValidation),
    defaultValues: async () => {
      let data: any = await props?.refetch()
      return {
        ...data?.data
      }
    }
  });

  const { handleEdit, isLoading, handleUpdateReturnCharge, returnChargeIsLoading } = props;
  const { data: statusList, } = useGetHook({
    queryKey: [`status`],
    url: `${APIS.STATUS}`,
    params: {
      is_final_state: true
    },
  });

  return (
    <>
      <Form
        handleSubmit={handleSubmit}
        handleFormSubmit={handleEdit}
        setError={setError}
        buttonLabel={"Update"}
        isLoading={isLoading}
      >
        <DeliveryChargeForm
          errors={errors}
          clearErrors={clearErrors}
          register={register}
          setValue={setValue}
          getValues={getValues}
        />
      </Form>

      <Form
        handleSubmit={handleSubmit}
        handleFormSubmit={handleUpdateReturnCharge}
        setError={setError}
        buttonLabel={"Update"}
        isLoading={returnChargeIsLoading}
      >
        <ReturnRateForm
          errors={errors}
          clearErrors={clearErrors}
          register={register}
          statusList={statusList}
          setValue={setValue}
          getValues={getValues}
          watch={watch}
        />
      </Form>
    </>

  );
}

export default EditDeliveryCharge
